import userService from "../../../services/user.service";

async function getDoctorSpecialization() {
  try {
    const response = await userService.getDoctorSpecialization(-1, 0, "");
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) ||
        "Failed to fetch doctor specializations."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error fetching doctor specializations:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

async function addDoctorSpecializationToDatabase({
  specializationName,
  specializationDescription,
}) {
  try {
    const payload = {
      name: specializationName,
      description: specializationDescription,
    };
    const response = await userService.addDoctorSpecialization(payload);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) ||
        "Failed to add doctor specialization."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error adding doctor specialization:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

async function updateDoctorSpecializationInDatabase({
  specializationId,
  specializationName,
  specializationDescription,
}) {
  try {
    const payload = {
      id: specializationId,
      name: specializationName,
      description: specializationDescription,
    };
    const response = await userService.updateDoctorSpecialization(payload);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) ||
        "Failed to update doctor specialization."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error updating doctor specialization:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

export default {
  addDoctorSpecializationToDatabase,
  getDoctorSpecialization,
  updateDoctorSpecializationInDatabase,
  doctorSpecializationTools: [
    {
      type: "function",
      function: {
        name: "getDoctorSpecialization",
        description:
          "Fetch all doctor specializations from the database. You must return all specializations without skipping any data unless explicitly told otherwise.",
        parameters: {
          type: "object",
          properties: {},
        },
      },
    },
    {
      type: "function",
      function: {
        name: "updateDoctorSpecializationInDatabase",
        description:
          "Update an existing doctor specialization in the database.",
        parameters: {
          type: "object",
          properties: {
            specializationId: {
              type: "string",
              description: "The unique ID of the specialization to be updated.",
            },
            specializationName: {
              type: "string",
              description: "Name of the specialization.",
            },
            specializationDescription: {
              type: "string",
              description: "Description of the specialization.",
            },
          },
          required: [
            "specializationId",
            "specializationName",
            "specializationDescription",
          ],
        },
      },
    },
    {
      type: "function",
      function: {
        name: "addDoctorSpecializationToDatabase",
        description: "Add a doctor specialization to the database.",
        parameters: {
          type: "object",
          properties: {
            specializationName: {
              type: "string",
              description: "Name of the specialization.",
            },
            specializationDescription: {
              type: "string",
              description: "Description of the specialization.",
            },
          },
          required: ["specializationName", "specializationDescription"],
        },
      },
    },
  ],
};
